class MessageBus {
    static instances = new Map();

    static get (name) {
        if (!this.instances.has(name)) {
            const inst = new MessageBus(name);
            this.instances.set(name, inst);
        }
        return this.instances.get(name);
    }

    static close (name) {
        const inst = this.instances.get(name);
        if (inst) {
            inst.close();
            this.instances.delete(name);
        }
    }

    constructor (name) {
        if (MessageBus.instances.has(name)) {
            return MessageBus.instances.get(name);
        }
        this._enabled = false;
        this._handlers = new Map();
        try {
            this.channel = new BroadcastChannel(name);
            this._enabled = true;
            this.channel.onmessage = this.messageEventHandler.bind(this);
            MessageBus.instances.set(name, this);
        } catch (e) {
            console.error('create BroadcastChannel failed:', e);
        }
    }

    get enabled () {
        return this._enabled;
    }

    messageEventHandler (e) {
        const { type, payload } = e.data || {};
        if (!this._handlers.has(type)) return;
        const evnHandlers = this._handlers.get(type);
        const evnTypes = this._handlers.get(`$types_${type}`);
        Array.from(evnHandlers).forEach((fn) => {
            if (typeof fn === 'function') {
                fn(payload);
            }
            if (evnTypes && evnTypes.has(fn) && evnTypes.get(fn) === 'once') {
                // 一次性监听，回调后删除
                evnHandlers.delete(fn);
            }
        });
    }

    close () {
        if (!this._enabled) return false;
        this.channel.close();
        this._handlers.clear();
        return true;
    }

    emit (type, payload) {
        if (!this._enabled) return false;
        this.channel.postMessage({ type, payload });
        return true;
    }

    once (type, listener) {
        if (this._handlers.has(type)) {
            this._handlers.get(type).add(listener);
            if (this._handlers.has(`$types_${type}`)) {
                this._handlers.get(`$types_${type}`).set(listener, 'once');
            } else {
                this._handlers.set(`$types_${type}`, new Map([
                    [ listener, 'once' ],
                ]));
            }
        }
        this._handlers.set(type, new Set([ listener ]));
        this._handlers.set(`$types_${type}`, new Map([
            [ listener, 'once' ],
        ]));
        return true;
    }

    on (type, listener) {
        if (this._handlers.has(type)) {
            const handlers = this._handlers.get(type);
            handlers.add(listener);
            if (this._handlers.has(`$types_${type}`)) {
                this._handlers.get(`$types_${type}`).set(listener, '');
            } else {
                this._handlers.set(`$types_${type}`, new Map([ [ listener, '' ] ]));
            }
            return () => {
                handlers.delete(listener);
            };
        }
        const handlers = new Set([ listener ]);
        const types = new Map([ [ listener, '' ] ]);
        this._handlers.set(type, handlers);
        this._handlers.set(`$types_${type}`, types);
        return () => {
            handlers.delete(listener);
        };
    }

    off (type, listener) {
        if (this._handlers.has(type)) {
            this._handlers.get(type).delete(listener);
            if (this._handlers.has(`$types_${type}`)) {
                this._handlers.get(`$types_${type}`).delete(listener);
            }
            return true;
        }
        return false;
    }
}

export default MessageBus;
